import React from "react";
import NatOp from "./NatOp";
import TPNF from "./TPNF";
import RefKey from "./RefKey";
import FinNFe from "./FinNFe";
import Intermediary from "./Intermediary";
import IsFinalConsumer from "./IsFinalConsumer";
import SendDate from "./SendDate";
import ManageStock from "./ManageStock";

export default (props) => (
  <React.Fragment>
    <div className="row">
    <div className="collumn col-lg-6 col-sm-12">
      <div className="">
        <NatOp />
      </div>
      <div className="">
        <TPNF />
      </div>
      <div className={props.simplified? "d-none" : ""}>
        <SendDate dateType="sendDate"/>
      </div>
    </div>
    <div className="collumn col-lg-6 col-sm-12">
      <div className="">
        <FinNFe />
      </div>
      <div className={props.simplified? "d-none" : ""}>
        <IsFinalConsumer />
      </div>
      <div className={props.simplified? "d-none" : ""}>
        <SendDate dateType="updateDate"/>
      </div>
      </div>
    </div>
    <ManageStock />
    <div className={props.simplified? "d-none" : "row my-2"}>
      <div className="col-12">
        <RefKey />
      </div>
    </div>
    <div  className={props.simplified? "d-none" : "row"}>
      <div className="col-12">
        <Intermediary />
      </div>
    </div>
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/index.jsx